export default {
  cooperativa: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  cooperativaContato: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  emailContato: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  telefoneContato: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/contacts/external/components/add/ce-form.js